import React, { useEffect, useRef, useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import { TranslateContext } from "../../../context/TranslateContext";

const AutoDeploy = () => {
  const canvasRef = useRef(null);
  const [clickCount, setClickCount] = useState(0);
  const [message, setMessage] = useState("");
  const { data } = React.useContext(TranslateContext);

  useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");

    const init = () => {
      const gradientColor = context.createLinearGradient(0, 0, 135, 135);
      gradientColor.addColorStop(0, "#267cee");
      gradientColor.addColorStop(1, "#6414e9");
      context.fillStyle = gradientColor;
      context.fillRect(0, 0, 200, 200);
      context.font = "bold 14px Tahoma";
      context.fillStyle = "#fff";
      context.textAlign = "center";
      context.fillText(data.scratchAndWin, 100, 40);
      context.font = "9px Tahoma";
      context.fillText(data.orContactWhatsApp, 100, 180);
      const img = new Image();
      img.onload = () => {
        context.drawImage(img, 50, 50, 100, 100);
      };
      img.src = "https://img.icons8.com/?size=512&id=12191&format=png";
    };

    const scratch = (x, y) => {
      context.globalCompositeOperation = "destination-out";
      context.beginPath();
      context.arc(x, y, 40, 0, 2 * Math.PI);
      context.fill();
    };

    const handleMouseDown = (e) => {
      isDragging = true;
      const { x, y } = getMousePosition(e);
      scratch(x, y);
    };

    const handleMouseMove = (e) => {
      if (!isDragging) return;
      const { x, y } = getMousePosition(e);
      scratch(x, y);
    };

    const handleMouseUp = () => {
      isDragging = false;
    };

    const getMousePosition = (e) => {
      const rect = canvas.getBoundingClientRect();
      return {
        x: e.clientX - rect.left,
        y: e.clientY - rect.top,
      };
    };

    let isDragging = false;
    canvas.addEventListener("mousedown", handleMouseDown);
    canvas.addEventListener("mousemove", handleMouseMove);
    canvas.addEventListener("mouseup", handleMouseUp);
    canvas.addEventListener("mouseleave", handleMouseUp);

    init();

    return () => {
      canvas.removeEventListener("mousedown", handleMouseDown);
      canvas.removeEventListener("mousemove", handleMouseMove);
      canvas.removeEventListener("mouseup", handleMouseUp);
      canvas.removeEventListener("mouseleave", handleMouseUp);
    };
  }, [data]);

  const handleCanvasClick = () => {
    setClickCount((prev) => prev + 1);
    if (clickCount === 1) {
      // setMessage("Text copied to clipboard!");
      // navigator.clipboard.writeText("GET 15% OFF");
      window.open("https://wa.me/918430088300?text=I need hosting for my app");
      setTimeout(() => setMessage(""), 3000);
    }
  };

  return (
    <Box
      id="scratch-card"
      sx={{
        height: "30vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        // backgroundColor: "white",
        position: "relative",
      }}
    >
      <Box
        id="back"
        sx={{
          position: "absolute",
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 200,
          width: 200,
          borderRadius: 1,
          backgroundColor: "rgba(238, 235, 235, 0.836)",
          boxShadow:
            "inset 6px 6px 10px 0 rgba(0, 0, 0, 0.2), inset -6px -6px 10px 0 rgba(255, 255, 255, 0.829)",
        }}
      >
        <Typography
          component="h3"
          sx={{
            borderStyle: "dotted",
            borderColor: "#267cee",
            width: 160,
            backgroundColor: "#fff",
            color: "black",
            zIndex: 2,
          }}
        >
          {data.clickHere}
        </Typography>
      </Box>
      <canvas
        ref={canvasRef}
        id="scratch"
        onClick={handleCanvasClick}
        width={200}
        height={200}
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          cursor: "grabbing",
          borderRadius: "0.3em",
          zIndex: 3,
        }}
      ></canvas>
      {message && (
        <Box
          sx={{
            position: "fixed",
            top: "50%",
            left: 0,
            padding: "10px",
            background: "#333",
            color: "#fff",
            transform: "translateX(0)",
            transition: "transform 0.5s ease-out",
          }}
        >
          {message}
        </Box>
      )}
    </Box>
  );
};

export default AutoDeploy;
